import { render, staticRenderFns } from "./resourceExport.vue?vue&type=template&id=4c4bbbb0&"
import script from "./resourceExport.vue?vue&type=script&lang=js&"
export * from "./resourceExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports